import axios from 'axios';

const crmIntegrationClient = axios.create();

export const register = (
  crmUrl,
  jwtToken,
  userId,
  userAgent,
  urlReferer,
  note,
) => crmIntegrationClient.post(
  `${crmUrl}/api/v2/integration/user`, {
    user_id: `${userId}`,
    origin: window.location.origin,
    timestamp: new Date().toISOString(),
    url_referer: urlReferer,
    user_agent: userAgent,
    note,
  },
  { headers: { Authorization: `bearer ${jwtToken}` } },
);

export const login = (
  crmUrl,
  jwtToken,
  userId,
  userAgent,
) => crmIntegrationClient.post(
  `${crmUrl}/api/v1/integration/login`, {
    user_id: `${userId}`,
    is_impersonated: false,
    timestamp: new Date().toISOString(),
    user_agent: userAgent,
    origin: window.location.origin,
  },
  { headers: { Authorization: `bearer ${jwtToken}` } },
);

export const bonus = (
  crmUrl,
  jwtToken,
  userId,
  amount,
  bonusCode,
  bonusId,
  bonusTurnedReal,
  currency,
  exchangeRate,
  lockedAmount,
  product,
  requiredWageringAmount,
  status,
  type,
  userBonusId,
) => crmIntegrationClient.post(
  `${crmUrl}/api/v1/integration/bonus`, {
    amount,
    bonus_code: bonusCode,
    bonus_id: bonusId,
    bonus_turned_real: bonusTurnedReal,
    currency,
    exchange_rate: exchangeRate,
    locked_amount: lockedAmount,
    origin: window.location.origin,
    product,
    required_wagering_amount: requiredWageringAmount,
    status,
    timestamp: new Date().toISOString(),
    type,
    user_bonus_id: userBonusId,
    user_id: `${userId}`,
  },
  { headers: { Authorization: `bearer ${jwtToken}` } },
);

export const payment = ( // eslint-disable-line
  crmUrl,
  jwtToken,
  userId,
  amount,
  bonusCode,
  currency,
  depositCount,
  exchangeRate,
  feeAmount,
  note,
  paymentId,
  status,
  type,
  vendorId,
  withdrawCount,
) => crmIntegrationClient.post(
  `${crmUrl}/api/v1/integration/payment`, {
    user_id: `${userId}`,
    amount,
    bonus_code: bonusCode,
    currency,
    deposit_count: depositCount,
    exchange_rate: exchangeRate,
    fee_amount: feeAmount,
    note,
    origin: window.location.origin,
    payment_id: paymentId,
    status,
    timestamp: new Date().toISOString(),
    type,
    vendor_id: vendorId,
    withdraw_count: withdrawCount,
  },
  { headers: { Authorization: `bearer ${jwtToken}` } },
);

export const useragent = ( // eslint-disable-line
  crmUrl,
  jwtToken,
  userId,
  timestamp,
  userAgent,
) =>
  crmIntegrationClient.post(
    `${crmUrl}/Integration/UserAgent`,
    { UserId: userId, Timestamp: timestamp, UserAgent: userAgent},
    { headers: { Authorization: 'bearer ' + jwtToken } },
  );
